import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { RoleModel } from 'projects/core/src/lib/models/role.model';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss']
})
export class RoleListComponent extends BaseList implements OnInit {

  public roles: Array<RoleModel> = [];

  protected rightLoad = 'admin.role.list';
  protected rightNew = 'admin.role.create';
  protected rightOpen = 'admin.role.show';
  protected apiUrl = '/roles';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.roles'));
    this.loading = true;
    this.api.getModels('roles').subscribe({
      next: (roles: any) => {
        this.roles = [];
        roles.data.forEach((role: any) => {
          role = new RoleModel().deserialize(role);
          role.setTranslocoService(this.transloco);
          this.roles.push(role);
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
